<div (click)="gamesSearch.toggleFiltersBar()" class="filter"
     [ngClass]="{
     'selected': gamesFilter?.filter?.categories?.length || gamesFilter?.filter?.providers?.length ||
     gamesSearch?.showFiltersBar || gamesFilter?.filter.attributes?.length
     }"
>
  <div class="filter__icon">
    <i class="icon-filter"></i>
  </div>
</div>
